import PropTypes from 'prop-types';
import React from 'react';
import { JobContext } from '../../../contexts/ContextCreator';
import Button from '../../Input/Button/Button';
import JobSearchAutocomplete from '../../Input/JobSearchAutoComplete/JobSearchAutocomplete';
import LocationInput from '../../Input/LocationInput/LocationInput';
import './JobSearchBar.scss';

export default class JobSearchBar extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            location: {
                coordinates: {
                    lat: props.lat,
                    lng: props.lng,
                },
                value: props.location,
                remote: false,
            },
            keywords: props.keywords,
        };
    }

    handleSubmit() {
        const { keywords, location } = this.state;
        const { companyUrl } = this.props;
        return this.context.searchForJobs(keywords, location, companyUrl);
    }

    onLocationChange = (location) => {
        this.setState({ location });
    };

    onKeywordsChange = (keywords) => {
        this.setState({ keywords });
    };

    renderBanner = () => {
        const { searchBarTitle } = this.props;
        const headerSml = 'headerSml';
        return (
            <React.Fragment>
                <div className={`search-header ${headerSml}`}>
                    {searchBarTitle}
                </div>
            </React.Fragment>
        );
    };

    render() {
        const { keywords, location } = this.state;
        const { searchBarTitle, searchTermPlaceholder } = this.props;
        let containerClasses = searchBarTitle ? '' : 'compact';
        const inputKeywordValue = keywords || '';
        const inputLocationValue = location.value || '';
        containerClasses += 'fullBanner';

        return (
            <div className={`component-JobV3-JobSearchBar ${containerClasses}`}>
                {this.renderBanner()}
                <form
                    // eslint-disable-next-line react/no-string-refs
                    ref="search-form"
                    method="get"
                    action="/jobs/find"
                    className="form"
                >
                    <JobSearchAutocomplete
                        onChange={this.onKeywordsChange}
                        value={inputKeywordValue}
                        name="keywords"
                        placeholder={searchTermPlaceholder}
                        classname="pt-2"
                        icon="magnifying-glass"
                    />
                    <LocationInput
                        onChange={this.onLocationChange}
                        value={inputLocationValue}
                        name="location"
                        placeholder="City, State or Country"
                        className="pt-2"
                        hasIcon
                        icon="new-location"
                    />
                    <Button
                        type="solid"
                        name="search"
                        formAction="submit"
                        value="Find jobs"
                        hover="no-hover-style"
                        onClick={(e) => {
                            e.preventDefault();
                            return this.handleSubmit();
                        }}
                    />
                </form>
            </div>
        );
    }
}

JobSearchBar.contextType = JobContext;

JobSearchBar.defaultProps = {
    searchBarTitle: '',
    searchTermPlaceholder: 'Search for Job title or Keyword',
    keywords: '',
    location: '',
    lat: null,
    lng: null,
    companyUrl: '',
};

JobSearchBar.propTypes = {
    /**
     * title text to display on the search bar
     */
    searchBarTitle: PropTypes.string,
    /**
     * placeholder for search input
     */
    searchTermPlaceholder: PropTypes.string,
    /**
     * keyword for search
     */
    keywords: PropTypes.string,
    /**
     * location for search
     */
    location: PropTypes.string,
    /**
     * latitude
     */
    lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /**
     * longitude
     */
    lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /**
     * Optional value to set if we are searching for a specific company
     */
    companyUrl: PropTypes.string,
};
